import {Component, Prop} from "vue-property-decorator";
import Modal from "@/assets/common/Modal/Modal.vue";
import ItemSelectModal from "@/assets/common/Modal/ItemSelectModal/ItemSelectModal.vue";

@Component({
    components: {
        Modal
    },
})
export default class QualityStandardSelectModal extends ItemSelectModal {
    @Prop({default: () => "品質・規格"})
    itemKindName!: string

    @Prop({default: () => "/quality_standards"})
    apiPath!: string;

    @Prop({default: () => true})
    multiple!: boolean

    @Prop({default: () => false})
    editable!: boolean
}
